import VueLoadmore from './vuejs-loadmore/index';

export default {
  install (Vue, options = {}) {
    Vue.component('Refresh', VueLoadmore);
  }
};

